import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeBillingStatusComponent } from './change-billing-status.component';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    Trip2ThemeModule,
    FormsModule
  ],
  declarations: [ChangeBillingStatusComponent],
  exports: [ChangeBillingStatusComponent],
  providers: [ReservationService]
})
export class ChangeBillingStatusModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/change-billing-status/change-billing-status.module.ts